export default {
  AX: "AX OfferteAanvraag",
  DA: "DA DocumentAanvraagBericht",
  DX: "DX DocumentBericht",
  EA: "EA ExterneBronAanvraag",
  EX: "EX ExterneBronBericht",
  GX: "GX NhgMelding",
  IA: "IA InformatieAanvraagBericht",
  IX: "IX InformatieBericht",
  KX: "KX KredietAanvraag",
  LX: "LX LevenAanvraag",
  MX: "MX BeheerVerzoek",
  NX: "NX NotarisOpdracht",
  OX: "OX Offerte",
  SX: "SX StatusMelding",
  TX: "TX TaxatieAanvraag",
  VX: "VX ValidatieFout",
};
